(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hs-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-delivery-estimate')) {
    class HsDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const addBusinessDays = (count) => {
          const date = new Date();
          let added = 0;
          while (added < count) {
            date.setDate(date.getDate() + 1);
            const day = date.getDay();
            if (day !== 0 && day !== 6) added++;
          }
          return date;
        };
        const locale = document.documentElement.lang || 'fr';
        const format = (date) => date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
        const span = (min, max) => format(addBusinessDays(Number(min))) + ' – ' + format(addBusinessDays(Number(max)));

        const arrive = span(this.dataset.totalMin, this.dataset.totalMax);
        const ship = this.querySelector('[data-ship]');
        const arriveEl = this.querySelector('[data-arrive]');
        const range = this.querySelector('[data-range]');
        if (ship) ship.textContent = span(this.dataset.prepMin, this.dataset.prepMax);
        if (arriveEl) arriveEl.textContent = arrive;
        if (range) range.textContent = arrive;
      }
    }
    customElements.define('hs-delivery-estimate', HsDeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hs-promo-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-promo-countdown')) {
    class HsPromoCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) * 1000;
        this.output = this.querySelector('[data-time]');
        this.tick();
        this.timer = setInterval(() => this.tick(), 30000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const diff = this.end - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          if (!window.Shopify?.designMode) this.hidden = true;
          return;
        }
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const pad = (value) => String(value).padStart(2, '0');
        if (this.output) {
          this.output.textContent = ' · ' + this.dataset.label + ' ' + days + ' j ' + pad(hours) + ' h ' + pad(minutes) + ' min';
        }
      }
    }
    customElements.define('hs-promo-countdown', HsPromoCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hs-size-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-size-finder')) {
    class HsSizeFinder extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.hs-size-finder__input');
        this.result = this.querySelector('.hs-size-finder__result');
        this.onInput = this.onInput.bind(this);
        this.input?.addEventListener('input', this.onInput);
      }

      disconnectedCallback() {
        this.input?.removeEventListener('input', this.onInput);
        clearTimeout(this.timer);
      }

      /** Radios du sélecteur de variantes de la même section, avec leur plage en cm. */
      getOptions() {
        const scope = this.closest('.shopify-section') || document;
        const radios = scope.querySelectorAll('variant-picker input[type="radio"]');
        const options = [];
        for (const radio of radios) {
          const match = String(radio.value).match(/(\d+)\s*[-–]\s*(\d+)\s*cm/i);
          if (match) options.push({ radio, min: Number(match[1]), max: Number(match[2]) });
        }
        return options.sort((a, b) => a.min - b.min);
      }

      onInput() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.recommend(), 350);
      }

      recommend() {
        const length = parseInt(this.input.value, 10);
        if (Number.isNaN(length) || length <= 0) {
          this.result.textContent = '';
          return;
        }
        const options = this.getOptions();
        if (!options.length) return;

        const first = options[0];
        const last = options[options.length - 1];
        if (length < first.min) {
          this.result.textContent = this.dataset.smallMessage;
          return;
        }
        if (length > last.max) {
          this.select(last.radio);
          this.result.textContent = this.dataset.cornerMessage;
          return;
        }

        let picked = options.find((option) => length >= option.min && length <= option.max);
        let between = false;
        if (!picked) {
          picked = options.find((option) => option.min > length);
          between = true;
        }
        if (!picked) return;

        this.select(picked.radio);
        const label = String(picked.radio.value).replace(/\s*\(?\s*\d+\s*[-–]\s*\d+\s*cm\s*\)?/i, '').trim();
        const template = between ? this.dataset.betweenMessage : this.dataset.matchMessage;
        this.result.textContent = template.replace('[taille]', label);
      }

      select(radio) {
        if (!radio.checked) radio.click();
      }
    }
    customElements.define('hs-size-finder', HsSizeFinder);
  }
  } catch(e) { console.error(e); }
})();

})();
